module.exports = __webpack_public_path__ + "static/media/Cover-home.db456796.jpg";